import { OCRModeEnum, UploadStatusEnum, UploadTypeEnum } from '@/shared/tools/ocr/enum';
import { OCRBackInfo, OCRFrontInfo } from '@/shared/tools/ocr/types';
import { getMaxQuotaText } from '@/shared/utils/getMaxQuota';

/** 身份证人像面字段 */
export const ID_CARD_FRONT: (keyof OCRFrontInfo)[] = ['idCardFrontUrl', 'idCardNo', 'userAddress', 'userBirth', 'userName', 'userNation', 'userSex', 'frontTransactionId'];

/** 身份证国徽面字段 */
export const ID_CARD_BACK: (keyof OCRBackInfo)[] = ['idCardBackUrl', 'issues', 'periodBegin', 'periodEnd', 'backTransactionId'];

/** 个人信息授权协议 */
export const ID_CARD_AUTH_PROTOCOL = 'https://kyc1.qcloud.com/s/h5/protocolTencent.html';

/** 顶部提示信息 JSON MAP
 * 类型： 通用、拍摄
 */
export const TIP_MSG_MAP = {
  /** 拍摄/相册 - 成功 */
  [UploadStatusEnum.SUCCESS]: {
    /** 仅人像面成功 */
    [OCRModeEnum.FRONT]: {
      title: '识别成功！',
      subTitle: '请继续上传国徽面',
    },
    [OCRModeEnum.BACK]: {
      title: '识别成功！',
      subTitle: '请继续上传人像面',
    },
    [OCRModeEnum.BOTH]: {
      title: '识别成功！',
      subTitle: '请核对身份信息，如有误请更正',
    },
  },
  /** 仅拍摄 - 双面超时 */
  [UploadStatusEnum.TIMEOUT_BOTH]: {
    title: '识别失败！',
    subTitle: '请重新拍摄或尝试其他方式',
  },
  /** 仅拍摄 - 人像面超时 */
  [UploadStatusEnum.TIMEOUT_FRONT]: {
    title: '人像面识别失败！',
    subTitle: '请重新拍摄或尝试其他方式',
  },
  /** 仅拍摄 - 国徽面超时 */
  [UploadStatusEnum.TIMEOUT_BACK]: {
    title: '国徽面识别失败！',
    subTitle: '请重新拍摄或尝试其他方式',
  },
  [UploadStatusEnum.API_FAIL_BOTH]: {
    [UploadTypeEnum.SDKCamera]: {
      title: '识别失败！',
      subTitle: '请重新拍摄或尝试其他方式',
    },
    [UploadTypeEnum.Album]: {
      title: '识别失败！',
      subTitle: '请重新上传或尝试其他方式',
    },
  },
  /** 仅相册 - 人像与国徽不匹配 */
  [UploadStatusEnum.NOT_MATCH]: {
    [OCRModeEnum.FRONT]: {
      title: '识别成功！',
      subTitle: '请继续上传人像面',
    },
    [OCRModeEnum.BACK]: {
      title: '识别成功！',
      subTitle: '请继续上传国徽面',
    },
  },
  /** 仅相册 - 单面未知失败 */
  [UploadStatusEnum.API_FAIL_UNKNOW]: {
    title: '识别失败！',
    subTitle: '请重新上传或尝试其他方式',
  },
  [UploadStatusEnum.FAIL]: {
    [OCRModeEnum.FRONT]: {
      title: '人像面识别失败！',
      subTitle: `上传成功后 最高可借${getMaxQuotaText()}`,
    },
    [OCRModeEnum.BACK]: {
      title: '国徽面识别失败！',
      subTitle: `上传成功后 最高可借${getMaxQuotaText()}`,
    },
    [OCRModeEnum.BOTH]: {
      title: '识别失败！',
      subTitle: `上传成功后 最高可借${getMaxQuotaText()}`,
    },
  },
};
